module.exports = __webpack_public_path__ + "fonts/Space.62c5b36.woff2";